module.exports = __webpack_public_path__ + "img/lp-money.30ea0875.svg";